import { MyAccountModel } from "../models/MyAccount";
import { UserListPayload, PortalUpdateData, UserMfaInfo, RegisterUser, SendLink, IResetPassword, AdminAccessListPayload, UpdateAgencyAccessPayload, UserState, SsoHpsUrlPayload, PostUserDetails, RefreshTokenPayload } from "../models/User";
import { DeactivateNotificationPayload } from "../routes/HeaderMenu/components/Notification";
import API from "./api";

export const getUserDetailByEmail = (baseUrl: string, payload: PostUserDetails) =>
  API.postApi(`${baseUrl}api/Admin/GetDetailsByUserEmail`, payload);

export const SendMfaCode = (baseUrl: string, payload: UserMfaInfo) =>
  API.postApi(`${baseUrl}api/MFA/SendOtp`, payload);

export const ResendMfaCode = (baseUrl: string, payload: UserMfaInfo) =>
  API.postApi(`${baseUrl}api/MFA/ResendOtp`, payload);

export const VerifyMfaCode = (baseUrl: string, payload: UserMfaInfo) =>
  API.postApi(`${baseUrl}api/MFA/VerifyOtp`, payload);

export const PostAddUser = (baseUrl: string, payload: MyAccountModel) =>
  API.postApi(`${baseUrl}api/Admin/UserDetails`, payload);

export const PostAdminUserList = (baseUrl: string, payload: UserListPayload) =>
  API.postApi(`${baseUrl}api/Admin/searchUserRecords`, payload);

export const GetAdminSelectedUserByEmail = (baseUrl: string, payload: PostUserDetails) =>
  API.postApi(`${baseUrl}api/Admin/GetDetailsByUserEmail`, payload);

export const PostAddPortalUpdate = (baseUrl: string, payload: PortalUpdateData) =>
  API.postApi(`${baseUrl}api/Admin/PortalUpdate`, payload);

export const GetPortalUpdate = (baseUrl: string) => 
  API.get(`${baseUrl}api/Admin/GetPortalUpdate`);

export const PostRegisterUser = (baseUrl: string, payload: RegisterUser, headers: any) =>
  API.postWithoutB2C(`${baseUrl}api/LoginUser/RegisterUser`, payload, headers);

export const GetUserByClaims = (baseUrl: string, headers: any) =>
  API.getWithoutB2C(`${baseUrl}api/LoginUser/GetUserByClaims`, headers);

export const SendForgotPasswordLink = (baseUrl: string, payload: SendLink) =>
  API.postWithoutB2C(`${baseUrl}api/LoginUser/SendResetPassword?emailId=${payload.email}`, payload);

export const PostResetPassword = (baseUrl: string, payload: IResetPassword, headers: any) =>
  API.patchWithoutB2C(`${baseUrl}api/LoginUser/ResetPassword`, payload, headers);

export const PostAccessAdminList = (baseUrl: string, payload: AdminAccessListPayload) =>
  API.postApi(`${baseUrl}api/Operator/getServiceProvidersPriorAuthButtonEnable`, payload);

export const PutAgencyAccessList = (baseUrl: string, payload: UpdateAgencyAccessPayload) =>
  API.putApi(`${baseUrl}api/Operator/updateServiceProvidersPriorAuthButtonEnable`, payload);

export const UserPageTrack = (baseUrl: string, payload: UserState) =>
  API.postApi(`${baseUrl}api/Portal/UserPageViewsDetails`, payload);

export const GetSsoHpsUrl = (baseUrl: string, payload: SsoHpsUrlPayload) =>
  API.get(`${baseUrl}api/HpsSso/samlSsoUrl?userId=${payload.userId}&npiId=${payload.npiId}`);

export const GetSAMLUrl = (baseUrl: string, payload: any) =>
  API.postWithoutB2C(`${baseUrl}api/Sso/ExchangeCodeForToken`, payload);

export const PostNotification = (baseUrl: string, payload: any) =>
  API.postApi(`${baseUrl}api/Notifications/saveNotification`, payload);

export const PostNotificationList = (baseUrl: string, payload: any) => 
  API.postApi(`${baseUrl}api/Notifications/getNotifications`, payload);

export const PutNotificationUpdate = (baseUrl: string, payload: any) =>
  API.putApi(`${baseUrl}api/Notifications/updateNotification`, payload);

export const DeactivateNotification = (baseUrl: string, payload: DeactivateNotificationPayload) => 
  API.putApi(`${baseUrl}api/Notifications/deactivateNotification`, payload);

export const LogoutPortalApp = (baseUrl: string) =>
  API.postApi(`${baseUrl}api/LoginUser/Logout`);

export const GetRefreshToken = (baseUrl: string, payload: RefreshTokenPayload) =>
  API.postWithoutB2C(`${baseUrl}api/Sso/RefreshToken`, payload);

export const GetSsoHppUrl = (baseUrl: string) =>
  API.get(`${baseUrl}api/HppSso/samlSsoUrl`);
